import { useEffect, useRef, useState } from "react";
import LottieView from 'lottie-react-native';

export function useLottieAnim() {
  const animation = useRef<LottieView>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Small delay to ensure component is mounted properly
    const timer = setTimeout(() => {
      if (animation.current) {
        animation.current.play();
        setIsReady(true);
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      // Don't set animation.current to null to prevent vanishing
      if (animation.current) {
        animation.current.reset();
      }
    };
  }, []);

  // Retry playing animation if it's not ready
  useEffect(() => {
    if (!isReady && animation.current) {
      const retryTimer = setTimeout(() => {
        animation.current?.play();
        setIsReady(true);
      }, 200);

      return () => clearTimeout(retryTimer);
    }
  }, [isReady]);

  return animation;
}
